import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import useDebounce from '../../../../../hooks/useDebounce';

export const useAsyncFilterOptions = <T>(queryKeyPrefix: string, searchFn: (query: string) => Promise<T[]>) => {
  const [query, setQuery] = useState('');
  const debounce = useDebounce(400);

  const { data, isLoading } = useQuery({
    queryKey: [queryKeyPrefix, query],
    queryFn: () => searchFn(query),
  });

  const handleSearch = (value: string) => {
    debounce(() => setQuery(value));
  };

  return { options: data ?? [], onSearch: handleSearch, isLoading };
};
